<template>
  <v-dialog scrollable persistent v-model="isActive" max-width="600">
    <v-card>
      <v-card-title class="blue darken-2 white--text">
        <span class="headline">共有の確認</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-layout wrap>
              <p class="body-2 px-3">{{ printName }}を共有してもよろしいですか？</p>
              <v-flex xs12 class="px-3">
                <v-select
                  v-model="form.aid"
                  label="手配中のフライト関連ファイルとしても登録する"
                  :items="getProgs"
                  item-text="text"
                  item-value="value"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat
          color="blue darken-2"
          @click="close">閉じる</v-btn>
        <v-btn depressed color="blue darken-2" class="white--text"
          :disabled="!isValid"
          :loading="isLoading"
          @click="submit">共有する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'shareModal',
  data () {
    return {
      config: {
        status: {
          loading: false,
          active: false
        }
      },
      form: {
        valid: true,
        aid: ''
      },
      rules: {
        aid: [
          v => !!v || '必須項目です'
        ]
      },
      store: {
        cid: '',
        item: null,
        progs: []
      }
    }
  },
  methods: {
    open: function (req) {
      const { cid, item } = req
      if (cid && item) {
        this.$set(this, 'form', {
          valid: true,
          option: false,
          aid: ''
        })
        this.$set(this, 'store', {
          cid, item
        })
        this.$nextTick(() => {
          this.get()
        })
        this.$set(this.config.status, 'active', true)
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    get: function () {
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}apply/get/items`, { cid: this.store.cid }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$set(this.store, 'progs', res.data.data)
          }
        }).catch(err => {
          console.log(err)
        })
      })
    },
    submit: function () {
      const urls = {
        share: `${this.$url.api}box/share/${this.store.cid}`,
        flight: `${this.$url.api}box/share/flight/${this.store.cid}`
      }
      if (this.store.item && this.$refs.form.validate()) {
        const { id, type, tags } = this.store.item
        const url = this.form.aid ? urls.flight : urls.share
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, {
            aid: this.form.aid,
            mid: id,
            type: type,
            tags: tags
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'shared',
                data: res.data.data
              })
              this.close()
              // this.store.items[idx].tags.push('shared')
              // this.$refs.item[jdx].state({
              //   type: 'loading',
              //   status: false
              // })
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isValid () {
      return this.form.valid
    },
    isOptionRequired () {
      return this.form.option
    },
    printName () {
      return (this.store.item && this.store.item.name) ? this.store.item.name : ''
    },
    getProgs () {
      return this.store.progs ? this.store.progs.map(it => {
        return {
          text: it.title,
          value: it.id
        }
      }) : []
    }
  }
}
</script>
